module.exports = __webpack_public_path__ + "img/garbage.752e1c3.png";